import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

/**
 * ComparisonSection — Premium glassmorphism comparison table.
 * Shows Cresta vs "Agendas normales" vs "Apps genéricas"
 */

const Check = () => <CheckCircle size={20} className="comparison-check" />;
const Cross = () => <XCircle size={20} className="comparison-cross" />;
const Warn = () => <AlertTriangle size={20} className="comparison-warn" />;

function ComparisonSection() {
    const rows = [
        {
            feature: '📱 WhatsApp nativo',
            cresta: <Check />, normal: <Cross />, generic: <Cross />,
        },
        {
            feature: '📢 Campañas masivas',
            cresta: <Check />, normal: <Cross />, generic: <Cross />,
        },
        {
            feature: '🔗 Reservas públicas',
            cresta: <Check />, normal: <Cross />, generic: <Warn />,
            genericNote: 'limitado'
        },
        {
            feature: '🚫 Anti-overbooking',
            cresta: <Check />, normal: <Cross />, generic: <Warn />,
            genericNote: 'parcial'
        },
        {
            feature: '💰 Precio en Beta',
            cresta: <span className="comparison-free">GRATIS</span>,
            normal: <span className="comparison-paid">💰 Caro</span>,
            generic: <span className="comparison-paid">💰 Caro</span>,
        },
        {
            feature: '🇨🇴 Diseñado para salones CO',
            cresta: <Check />, normal: <Cross />, generic: <Cross />,
        },
        {
            feature: '📊 Comisiones de estilistas',
            cresta: <Check />, normal: <Cross />, generic: <Warn />,
            genericNote: 'manual'
        },
        {
            feature: '📦 Inventario multi-ubicación',
            cresta: <Check />, normal: <Cross />, generic: <Cross />,
        },
    ];

    return (
        <section className="comparison-section">
            <div className="section-container">
                <div className="section-header">
                    <span className="section-badge">¿POR QUÉ CRESTA?</span>
                    <h2 className="section-title">
                        Diseñado para salones,
                        <span className="gradient-text"> no para todos</span>
                    </h2>
                    <p className="section-description">
                        La mayoría de apps son genéricas. Cresta fue construida <strong>específicamente para salones de belleza latinoamericanos</strong>  — con sus integraciones, su idioma y sus necesidades.
                    </p>
                </div>

                <div className="comparison-wrapper">
                    <div className="comparison-table">
                        {/* Table head */}
                        <div className="comparison-head">
                            <div className="comparison-head-feature">Característica</div>
                            <div className="comparison-head-cresta">
                                <div className="comparison-cresta-badge">✨ Cresta</div>
                            </div>
                            <div className="comparison-head-other">Agendas normales</div>
                            <div className="comparison-head-other">Apps genéricas</div>
                        </div>

                        {/* Rows */}
                        {rows.map((row, i) => (
                            <div key={i} className={`comparison-row ${i % 2 === 0 ? 'comparison-row-even' : ''}`}>
                                <div className="comparison-cell-feature">{row.feature}</div>
                                <div className="comparison-cell-cresta">{row.cresta}</div>
                                <div className="comparison-cell-other">{row.normal}</div>
                                <div className="comparison-cell-other">
                                    {row.generic}
                                    {row.genericNote && (
                                        <span className="comparison-note">{row.genericNote}</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom note */}
                <p className="comparison-footnote">
                    * Comparación basada en funcionalidades disponibles en la beta actual de Cresta.
                </p>
            </div>
        </section>
    );
}

export default ComparisonSection;
